module.exports = "mutation ($id: ID!) {\n  FormDelete(id: $id) {\n    id\n  }\n}\n"